import React, { useState } from "react";
import { api } from "../../../api/apiService";

export default function NotifyAbhaButton({ patientId }) {
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(false);

  const handleClick = async (e) => {
    e?.stopPropagation();
    if (loading || done) return;
    setError(false);
    setLoading(true);
    try {
      await api.post(`/patient/${patientId}/notify2`);
      setDone(true);
    } catch (err) {
      console.error("Notify ABHA error:", err);
      setError(true);
      setTimeout(() => setError(false), 3000);
    } finally {
      setLoading(false);
    }
  };

  if (error) {
    return (
      <span style={{ fontSize: "12px", color: "#dc3545", fontWeight: 500 }}>
        Failed. Retry?{" "}
        <button
          onClick={handleClick}
          className="btn btn-sm btn-outline-danger"
          style={{ fontSize: "11px", padding: "1px 6px" }}
        >
          ↺
        </button>
      </span>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={loading || done}
      style={{ fontSize: "12px", padding: "3px 16px" }}
      className={`btn btn-sm ${done ? "btn-success" : "btn-outline-primary"}`}
    >
      {done ? "Notified " : loading ? "Sending…" : "Notify"}
    </button>
  );
}
